var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 342 342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:currentColor;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "z-ctrl-blk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 342,
    height: 342
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M152.35,170.46l-12.18-12.19a.5.5,0,0,0-.35-.14.48.48,0,0,0-.34.14l-34.41,34.41V106.15a.51.51,0,0,0-.3-.46l-.19,0a.52.52,0,0,0-.35.14L39.58,170.46a.49.49,0,0,0-.15.34.51.51,0,0,0,.15.35l12.18,12.18a.47.47,0,0,0,.35.14.45.45,0,0,0,.34-.14l34.41-34.41v86.54a.49.49,0,0,0,.3.45.43.43,0,0,0,.19,0,.45.45,0,0,0,.34-.15l64.66-64.65A.49.49,0,0,0,152.35,170.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M185.24,49.85,173.06,37.66a.49.49,0,0,0-.34-.14.52.52,0,0,0-.35.14l-56,56a.49.49,0,0,0,0,.69l12.18,12.19a.52.52,0,0,0,.35.14.49.49,0,0,0,.34-.14l56-56A.47.47,0,0,0,185.24,49.85Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M229.1,93.7,216.92,81.52a.51.51,0,0,0-.34-.14.52.52,0,0,0-.35.14l-56,56a.49.49,0,0,0,0,.69l12.18,12.19a.52.52,0,0,0,.35.14.49.49,0,0,0,.34-.14l56-56A.49.49,0,0,0,229.1,93.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M207.17,71.77,195,59.59a.49.49,0,0,0-.34-.14.52.52,0,0,0-.35.14l-56,56a.49.49,0,0,0,0,.69l12.18,12.19a.52.52,0,0,0,.35.14.49.49,0,0,0,.34-.14l56-56A.49.49,0,0,0,207.17,71.77Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M219.71,243.93H176.34V188.38a.49.49,0,0,0-.3-.45.43.43,0,0,0-.19,0,.49.49,0,0,0-.35.15l-64.65,64.65a.49.49,0,0,0,0,.69L123,265.57a.5.5,0,0,0,.35.14.48.48,0,0,0,.34-.14l34.41-34.41v74.35a.49.49,0,0,0,.49.49h17.23a.49.49,0,0,0,.49-.49V262.14h43.37a.49.49,0,0,0,.49-.49V244.42A.49.49,0,0,0,219.71,243.93Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M305.86,170.46l-56-56.05a.51.51,0,0,0-.7,0l-56,56.05a.48.48,0,0,0-.14.34.5.5,0,0,0,.14.35l56,56a.51.51,0,0,0,.7,0l56-56A.49.49,0,0,0,305.86,170.46Zm-56.39,31.33-31-31,31-31,31,31Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZero);
export default __webpack_public_path__ + "static/media/zero.e0e7742550ab461677951a0299e8f5ce.svg";
export { ForwardRef as ReactComponent };